import { DeleteOutlineRounded, DeleteRounded, Description, InsertDriveFile, PictureAsPdf, CheckCircle } from "@mui/icons-material";
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Grid,
  Modal,
  Paper,
  Radio,
  Slide,
  Typography,
  Chip,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { userSelector } from "../../../user-redux/selector";
import {
  selectedResume,
  selectedTabViewAction,
  updateSubmissionsAction,
} from "../../redux/action";
import Key from "../../../../clientVariables.json";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import moment from "moment";
import axios from "axios";
import { myCandidatesSelector } from "../../redux/selector";
import { formatDistanceToNow } from "date-fns";

// Helper function to format time without "about"
const formatTimeAgo = (date) => {
  if (!date) return "";
  const timeAgo = formatDistanceToNow(new Date(date), { addSuffix: true });
  // Remove "about" and clean up the string
  return timeAgo.replace(/^about\s+/i, "").replace(/^less than a minute ago$/i, "Just now");
};

// Helper function to check if file is PDF
const isPdfFile = (resume) => {
  // Check MIME type first
  if (resume.type === "application/pdf") return true;
  // Fallback to filename extension check
  if (resume.filename && resume.filename.toLowerCase().endsWith('.pdf')) return true;
  if (resume.name && resume.name.toLowerCase().endsWith('.pdf')) return true;
  return false;
};


// Accept Job Manually
const Step2 = () => {
  const [file, setFile] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const dispatch = useDispatch();
  const { user } = useSelector(userSelector);

  const {
    submissionSelectedResume,
    selectedSubmission,
    candidateDetails,
  } = useSelector(myCandidatesSelector);
  const [openSuccessToast, setOpenSuccessToast] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [openFileSelection, setOpenFileSelection] = useState(false);
  const openFileSelectionRef = useRef(null);
  const [candidateResumesList, setCandidateResumesList] = useState([]);

  useEffect(() => {
    let isMounted = true;

    const fetchResumes = async () => {
      try {
        if (candidateDetails?.candidate_id) {
          const response = await axios.post(
            `${Key.domain}/common/get_candidate_resumes_list`,
            {
              candidate_id: candidateDetails.candidate_id,
              user_id: candidateDetails.user_id,
            }
          );


          if (response?.data?.success === 1 && isMounted) {
            setCandidateResumesList(response?.data?.data || []);
            const primaryResume = response?.data?.data?.find(
              (resume) => resume.isPrimary === 1
            );
            const selectedFile = primaryResume || response?.data?.data?.[0];
            if (selectedFile) {
              setFile(selectedFile);
            }
          }
        }
      } catch (error) {
        console.error('Error fetching resumes:', error);
      }
    };

    fetchResumes();

    return () => {
      isMounted = false;
    };
  }, [candidateDetails]);

  useEffect(() => {
    if (submissionSelectedResume) {
      console.log(submissionSelectedResume);
      setFile(submissionSelectedResume);
    }
  }, [submissionSelectedResume]);

  useEffect(() => {
    if (
      candidateResumesList?.length > 0 &&
      !submissionSelectedResume?.resume_id
    ) {
      const primaryResume = candidateResumesList?.find(
        (resume) => resume.isPrimary === 1
      );

      let selectedFile;
      if (primaryResume && primaryResume?.filename) {
        selectedFile = primaryResume;
      } else {
        selectedFile = candidateResumesList?.[0];
      }
      setFile(selectedFile);
      dispatch(selectedResume(selectedFile));
    }
  }, [candidateResumesList]);

  const controlProps = (item) => ({
    checked: file && file.resume_id === item.resume_id,
    onChange: () => handleFileChange(item), // Pass the entire resume object to the function
    value: item.resume_id,
    name: "size-radio-button-demo",
    inputProps: { "aria-label": item.resume_id },
  });

  useEffect(() => {
    if (
      candidateResumesList?.length > 0 &&
      !submissionSelectedResume?.resume_id
    ) {
      const primaryResume = candidateResumesList?.find(
        (resume) => resume.isPrimary === 1
      );

      let selectedFile;
      if (primaryResume && primaryResume?.filename) {
        selectedFile = primaryResume;
      } else {
        selectedFile = candidateResumesList?.[0];
      }
      setFile(selectedFile);
      dispatch(selectedResume(selectedFile));
    }
  }, [candidateResumesList]);

  useEffect(() => {
    if (
      candidateResumesList?.length > 0 &&
      selectedSubmission &&
      !submissionSelectedResume?.resume_id
    ) {
      const primaryResume = candidateResumesList?.find(
        (resume) => resume.isPrimary === 1
      );
      const selectedFile = primaryResume || candidateResumesList?.[0];
      setFile(selectedFile);
      dispatch(selectedResume(selectedFile));
    }
  }, [candidateResumesList, selectedSubmission]);

  useEffect(() => {
    if (submissionSelectedResume) {
      setFile(submissionSelectedResume);
    }
  }, [submissionSelectedResume]);


  useEffect(() => {

    if (submissionSelectedResume) {
      setFile(submissionSelectedResume);
      return;
    }

    if (!selectedSubmission?.candidate_id) return;

    // Always check and set the primary resume
    if (candidateResumesList?.length > 0) {
      const primaryResume = candidateResumesList?.find((resume) => resume.isPrimary === 1);
      let selectedFile = primaryResume ?? candidateResumesList[0];
      setFile(selectedFile);
      dispatch(selectedResume(selectedFile));
    } else {
      setFile(null); // If no resumes, clear file
    }
  }, [selectedSubmission?.candidate_id]);


  const handleSuccessToastClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSuccessToast(false);
  };

  const handleFileChange = (item) => {
    setFile(item);
  };
  const handleSubmit = async () => {
    setIsSubmitting(true);
    const data = new FormData();
    data.append("file", file);
    data.append("userid", user?.id);
    data.append("candidateid", selectedSubmission.candidate_id);
    data.append("filename", file?.name);
    data.append("file_size", file?.size);
    data.append("file_type", file?.type);
    data.append("attachment_type", "Candidate_res_attachment");
    data.append("attachment_name", file?.name);
    data.append("file_created", file?.lastModifiedDate);

    try {
      if (file !== null) {
        const response = await axios.post(
          `${Key.domain}/submission/accept_manually`,
          {
            candidateid: selectedSubmission?.candidate_id,
            jobid: selectedSubmission?.job_id,
            userid: selectedSubmission?.user_id,
            resumeid: file?.resume_id,
          }
        );

        const uploadedFileName = file?.name;
        setUploadedFile(uploadedFileName);
        let updatedData = {
          candidateid: selectedSubmission?.candidate_id,
          jobid: selectedSubmission?.job_id,
          userid: selectedSubmission.user_id,
          status: "2",
        };
        await dispatch(
          updateSubmissionsAction(
            updatedData,
            selectedSubmission.user_id,
            selectedSubmission?.candidate_id,
            selectedSubmission?.job_id
          )
        )
          .then(() => {
            setOpenSuccessToast(true);
          })
          .catch((error) => { })
          .finally(() => {
            setIsSubmitting(false);
          });
      } else {
        let updatedData = {
          candidateid: selectedSubmission?.candidate_id,
          jobid: selectedSubmission?.job_id,
          userid: selectedSubmission.user_id,
          status: "2",
        };
        await dispatch(
          updateSubmissionsAction(
            updatedData,
            selectedSubmission.user_id,
            selectedSubmission?.candidate_id,
            selectedSubmission?.job_id
          )
        );
      }
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  const onResumeSelection = () => {
    dispatch(selectedTabViewAction("Resume Selection"));
  };

  const onRemoveSelectedResume = () => {
    dispatch(selectedResume({}));
  };
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div style={{ width: "100%", marginTop: "30px" }}>
        <Box sx={{ display: "flex", justifyContent: "center", width: "100%", mb: 1 }}>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              background: "linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
              mb: 3,
              letterSpacing: "-0.5px",
            }}
          >
            Select Resume for Submission
          </Typography>
        </Box>

        {/* Display all resumes with radio buttons */}
        {candidateResumesList && candidateResumesList.length > 0 ? (
          <Box
            sx={{
              maxHeight: "450px",
              overflowY: "auto",
              px: { xs: 3, xl: 1 },
              mb: 3,
              "&::-webkit-scrollbar": {
                width: "8px",
              },
              // "&::-webkit-scrollbar-track": {
              //   background: "#f1f1f1",
              //   borderRadius: "10px",
              // },
              // "&::-webkit-scrollbar-thumb": {
              //   background: "linear-gradient(180deg, #1976d2 0%, #42a5f5 100%)",
              //   borderRadius: "10px",
              // },
              // "&::-webkit-scrollbar-thumb:hover": {
              //   background: "linear-gradient(180deg, #42a5f5 0%, #1976d2 100%)",
              // },
            }}
          >
            <Grid container spacing={2} py={2}>
              {candidateResumesList.map((resume, index) => (
                <Grid item xs={12} lg={12} xl={6} key={index}>
                  <Card
                    sx={{
                      position: "relative",
                      background: file?.resume_id === resume.resume_id
                        ? "linear-gradient(135deg, #1976d215 0%, #42a5f515 100%)"
                        : "#ffffff",
                      boxShadow: file?.resume_id === resume.resume_id
                        ? "0 8px 24px rgba(25, 118, 210, 0.25)"
                        : "0 2px 8px rgba(0, 0, 0, 0.08)",
                      borderRadius: "10px",
                      border: file?.resume_id === resume.resume_id
                        ? "2px solid transparent"
                        : "1px solid #e8e8e8",
                      backgroundImage: file?.resume_id === resume.resume_id
                        ? "linear-gradient(white, white), linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)"
                        : "none",
                      backgroundOrigin: "border-box",
                      backgroundClip: file?.resume_id === resume.resume_id
                        ? "padding-box, border-box"
                        : "padding-box",
                      cursor: "pointer",
                      transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                      overflow: "hidden",
                      "&:hover": {
                        boxShadow: "0 12px 32px rgba(25, 118, 210, 0.3)",
                        transform: "translateY(-4px) scale(1.01)",
                      },
                    }}
                    onClick={() => {
                      setFile(resume);
                      dispatch(selectedResume(resume));
                    }}
                  >


                    <Grid container alignItems="center" sx={{ width: '100%' }}>
                      {/* File Type Icon Section */}
                      <Grid
                        item
                        xs={1.5}
                        xl={2}
                        sx={{
                          background: isPdfFile(resume)
                            ? "linear-gradient(135deg, #e40321ff 100%, #f093fb 0%)"
                            : "linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)",
                          color: "#fff",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          py: 1,
                          gap: 0.5,
                          position: "relative",
                          "&::after": {
                            content: '""',
                            position: "absolute",
                            right: 0,
                            top: "50%",
                            transform: "translateY(-50%)",
                            width: "1px",
                            height: "60%",
                            background: "rgba(255, 255, 255, 0.3)",
                          },
                        }}
                      >
                        <Description sx={{ fontSize: 32, mb: 0.5 }} />
                        <Typography
                          sx={{
                            fontSize: "11px",
                            fontWeight: 700,
                            letterSpacing: "0.5px",
                          }}
                        >
                          {isPdfFile(resume) ? "PDF" : "DOC"}
                        </Typography>
                      </Grid>

                      {/* Resume Details Section */}
                      <Grid item xs={10.5} xl={10} sx={{ p: 1, pl: { xs: 2, sm: 2, md: 2, lg: 2, xl: 1.5 } }}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0, justifyContent: "space-between" }}>
                          <Typography
                            title={resume.filename?.trim().replace(/^(CAND_)+/i, "") || resume.name}
                            sx={{
                              fontWeight: 600,
                              fontSize: "14px",
                              color: "#2d3748",
                              lineHeight: 1.4,
                              flex: 1,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {resume.filename?.trim().replace(/^(CAND_)+/i, "") || resume.name}
                          </Typography>
                          {/* Radio Button - Top Right aligned with filename */}
                          <Radio
                            {...controlProps(resume)}
                            sx={{
                              color: "#cbd5e0",
                              "&.Mui-checked": {
                                color: "#1976d2",
                              },
                              "& .MuiSvgIcon-root": {
                                fontSize: 24,
                              },
                              "&:hover": {
                                backgroundColor: "rgba(25, 118, 210, 0.08)",
                              },
                              p: 0.5,
                            }}
                          />
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1, justifyContent: "space-between" }}>
                          <Typography
                            sx={{
                              fontSize: "13px",
                              color: "#718096",
                              fontWeight: 500,
                              display: "flex",
                              alignItems: "center",
                              gap: 0.5,
                            }}
                          >
                            {formatTimeAgo(resume?.created)}
                          </Typography>
                          {/* PRIMARY Badge - Bottom beside timestamp */}
                          {resume.isPrimary === 1 && (
                            <Chip

                              label="PRIMARY"
                              size="small"
                              sx={{
                                backgroundColor: "#0bbd79ff",
                                mt: 0.4,
                                color: "#fff",
                                fontWeight: 700,
                                fontSize: "9px",
                                height: "20px",
                                letterSpacing: "0.5px",
                                borderRadius: '4px',
                                p: 0.4,
                                boxShadow: "0 2px 8px rgba(17, 153, 142, 0.3)",
                                "& .MuiChip-icon": {
                                  marginLeft: "4px",
                                },
                              }}
                            />
                          )}
                        </Box>
                      </Grid>


                    </Grid>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>
        ) : (
          <Box sx={{ textAlign: "center", py: 6 }}>
            <InsertDriveFile sx={{ fontSize: 64, color: "#cbd5e0", mb: 2 }} />
            <Typography
              sx={{
                color: "#718096",
                fontSize: "15px",
                fontWeight: 500,
              }}
            >
              No resumes found for this candidate
            </Typography>
          </Box>
        )}

        {/* Selected Resume Display */}
        {file !== null && file && file.filename && (
          <Box
            sx={{
              display: "flex",
              gap: 2,
              alignItems: "center",
              justifyContent: "center",
              mt: 2,
              mx: 3,
              p: 2.5,
              background: "linear-gradient(135deg, #1976d215 0%, #42a5f515 100%)",
              borderRadius: "12px",
              border: "1px solid #1976d230",
              boxShadow: "0 4px 12px rgba(25, 118, 210, 0.15)",
            }}
          >
            <CheckCircle sx={{ color: "#1976d2", fontSize: 24 }} />
            <Typography
              sx={{
                fontSize: "15px",
                color: "#2d3748",
                fontWeight: 600,
                m: 0,
                flex: 1,
              }}
            >
              Selected: {file.filename.trim().replace(/^(CAND_)+/i, "")}
            </Typography>
          </Box>
        )}

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            marginTop: "30px",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            size="small"
            sx={{ width: 120, textTransform: "capitalize" }}
            onClick={handleSubmit}
            disabled={!file || !file?.filename || ["Selected", "Rejected"].includes(selectedSubmission?.pStatusName) || selectedSubmission?.bench_status_id !== 1}
          >
            {isSubmitting ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              "Accept"
            )}
          </Button>
        </Box>
      </div>
      <Modal
        open={openFileSelection}
        onClose={() => {
          setOpenFileSelection(false);
          // dispatch(clearRedirect());
        }}
      >
        <Slide
          direction="left"
          in={openFileSelection}
          container={openFileSelectionRef.current}
          mountOnEnter
          unmountOnExit
          timeout={{ enter: 1000, exit: 1000 }}
        //   style={{ transitionTimingFunction: 'cubic-bezier(0.68, -0.55, 0.27, 1.55)'  }}
        >
          <Paper
            elevation={4}
            style={{
              // padding: 16,
              transition: "opacity 2s ease-in-out",
              // transform: 'scale(1)', transition: 'transform 0.5s ease-in-out',
              // boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', transition: 'box-shadow 0.5s ease-in-out' ,
              // backgroundColor: '#FFF', color: '#333', transition: 'background-color 0.5s ease-in-out, color 0.5s ease-in-out',

              ...modalStyles,
            }}
          >
            <Grid container spacing={2}>
              <Grid item sm={4}>
                {candidateResumesList.map((resume, index) => (
                  <Grid item xs={12} key={index}>
                    <Card
                      sx={{
                        boxShadow: "none",
                        borderRadius: "8px",
                        border: "1px solid #ddd",
                      }}
                    >
                      <Grid container>
                        <Grid
                          item
                          xs={1.5}
                          sx={{
                            bgcolor:
                              resume.type === "application/pdf"
                                ? "#d32f2f"
                                : "#1976d2",
                            color: "#fff",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {resume.type === "application/pdf" ? "PDF" : "Docs"}
                        </Grid>
                        <Grid item xs={9.5} sx={{ p: 2 }}>
                          <Typography paragraph sx={{ mb: 0, fontWeight: 500 }}>
                            {resume.name}
                          </Typography>
                          <Typography
                            paragraph
                            sx={{ mb: 0, fontSize: "12px", color: "#757575" }}
                          >
                            {resume.lastModified !== undefined &&
                              resume.lastModified !== null
                              ? moment(resume.lastModified).fromNow() !==
                                "Invalid date"
                                ? moment(resume.lastModified).fromNow()
                                : moment("2022-03-31T06:26:04.138Z").fromNow()
                              : moment("2022-03-31T06:26:04.138Z").fromNow()}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          xs={1}
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <Radio
                            {...controlProps(resume)}
                            sx={{
                              "& .MuiSvgIcon-root": {
                                fontSize: 28,
                              },
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Paper>
        </Slide>
      </Modal>
      <Snackbar
        open={openSuccessToast}
        autoHideDuration={6000}
        onClose={handleSuccessToastClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert onClose={handleSuccessToastClose} severity="success">
          File Uploaded successfully!
        </MuiAlert>
      </Snackbar>
    </div>
  );
};

export default Step2;

const modalStyles = {
  position: "absolute",
  top: "5%",
  left: "10%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  bgcolor: "background.paper",
  // border: '2px solid #000',
  border: "none",
  boxShadow: 24,
  p: 4,
  borderRadius: "8px",
  height: "80vh",
  overflow: "scroll",
};
